module.exports = __webpack_public_path__ + "static/media/schlauch_schema.22e21364.jpg";